<template>
  <div class="cittadino-layout">
    <a class="skip-link" href="#cittadino-main-content">
      {{ $t('AccessibilityToolbar.skipToContent') }}
    </a>
    <PopupModal v-if="popupEnabled" />
    <SomministraCustomTeleconsultoSurvey
      serviceName="emergenza"
      v-if="activeRefs.includes(10)"
    />
    <SomministraCustomTeleconsultoSurvey
      serviceName="tc_pediatrico"
      v-if="activeRefs.includes(11)"
    />
    <div class="cittadino-layout__grid">
      <nav
        class="nav-desktop"
        :style="{ 'z-index': menuZindex }"
        :aria-label="$t('CittadinoMain.navigazione_cittadino')"
      >
        <NavigationCittadino :wlistener="innerWidth" />
      </nav>

      <section class="main-operatore">
        <header class="cittadino-layout__header">
          <CittadinoTopHeader />
        </header>
        <main
          id="cittadino-main-content"
          class="cittadino-layout__main px-4 pt-2"
          data-page-focus
          role="main"
          tabindex="-1"
        >
          <router-view />
        </main>
      </section>
    </div>
    <template v-if="$root.scope === 'concura'">
      <CallSupportModal
        :onlysupport="true"
        class="call-support-modal"
        style="position: fixed; bottom: 21px; right: 97px"
      />
      <CallSupportModal />
    </template>
  </div>
</template>
<script>
import { mapState } from "vuex";
import NavigationCittadino from "@/app/layout/components/NavigationCittadino.vue";
import CallSupportModal from "@/app/layout/components/CallSupportModal.vue";
import CittadinoTopHeader from "@/app/layout/components/CittadinoTopHeader.vue";
import PopupModal from "@/app/modules/statistiche/components/PopupModal.vue";
import SomministraCustomTeleconsultoSurvey from "@/app/modules/servizi/teleconsulto/components/SomministraCustomTeleconsultoSurvey.vue";

export default {
  name: "CittadinoMain",
  components: {
    NavigationCittadino,
    CallSupportModal,
    CittadinoTopHeader,
    PopupModal,
    SomministraCustomTeleconsultoSurvey,
  },
  data() {
    return {
      innerWidth: window.innerWidth,
      popupEnabled: process.env.VUE_APP_POPUP_ENABLED,
    };
  },
  computed: {
    ...mapState("utente", ["status", "user"]),
    ...mapState("modal", ["closable", "open", "canNavigate"]),
    ...mapState("settings", ["activeRefs"]),
    menuZindex: function () {
      if (this.open && this.canNavigate) {
        return 2040;
      }
      return 5;
    },
  },
  methods: {
    innerWidthChanged() {
      // console.log("resize handler");
      this.innerWidth = window.innerWidth;
    },
  },
  created() {
    if (this.user.type !== 0) {
      this.$router.push({ name: "Home" });
    }

    // this.setupWidgetVariables()
    window.addEventListener("resize", this.innerWidthChanged);
  },
  mounted() {
    if (
      this.user.expired_password == 1 &&
      this.$route.name !== "ImpostazioniCittadinoMain"
    ) {
      this.$router.push({
        name: "ImpostazioniCittadinoMain",
        query: { scope: "expired" },
      });
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.innerWidthChanged);
  },
};
</script>

<style scoped>
.cittadino-layout {
  position: relative;
}

.skip-link {
  position: absolute;
  top: -40px;
  left: 10px;
  background-color: #ffffff;
  color: #000;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  z-index: 3000;
}

.skip-link:focus {
  top: 10px;
}

.cittadino-layout__grid {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
}

.cittadino-layout__header {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 0 0;
}

.cittadino-layout__main {
  outline: none;
  min-height: 60vh;
}

@media (max-width: 991px) {
  .cittadino-layout__grid {
    flex-direction: column;
  }

  .cittadino-layout__header {
    padding: 0;
  }

  .cittadino-layout__main {
    padding: 1rem !important;
  }
}
</style>
